import { toJSON } from "../data/JSON";
import { PropertyChangedEventArgs } from "./PropertyChangedEventArgs";
export class PropertyObservedEventArgs extends PropertyChangedEventArgs {
  get oldValue() {
    return this._oldValue;
  }

  get newValue() {
    return this._newValue;
  }

  get propertyChanged() {
    return this._propertyChanged;
  }

  constructor(propertyName, _oldValue, _newValue, _propertyChanged) {
    super(propertyName);
    this._oldValue = _oldValue;
    this._newValue = _newValue;
    this._propertyChanged = _propertyChanged;
    this.toJSON = void 0;
    this.toJSON = toJSON;
  }

}
